import React, { Suspense, useCallback, useState, useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Styled from 'styled-components'
import { useApiContext } from '../Hooks/useApiContext'
import { extractBorrowerAndCoborrowers } from '../Utils/apiExtractors'
import { useLoggedInUser } from '../Hooks/useLoggedInUser'
import ScrollToTop from '../Global/ScrollToTop'
import LoadingPage from '../Components/LoadingPage'

import { useLocation, useNavigate } from 'react-router-dom'

import { LandingPageBannerModern } from './LandingPageBannerModern.jsx'
import { PrepaymentBanner } from './PrepaymentBanner.jsx'
import { InsuranceClaimBanner } from './InsuranceClaimBanner.jsx'
import { CommonQuestionsModern } from './CommonQuestionsModern.jsx'
import { CommonFormsModern } from './CommonFormsModern.jsx'
import BannerAnnouncing from './banners/BannerAnnouncing.jsx'
import BannerMFAPreLoginFiveThousand from './banners/BannerMFAPreLoginFiveThousand.jsx'
import { GET_LOAN_KEY, GET_PAPERLESS_KEY, GET_TRANSACTIONS_KEY } from '../services/api.js'
import { useIdleLogout } from '../Utils/useIdleLogout.js'
// import BannerAuth0August from './banners/BanneAuth0August.js'
// import BannerAuth0 from './BannerAuth0.js'
import { useAuth0 } from '@auth0/auth0-react'
export const SIGN_IN = 'SIGN_IN'
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const CONFIRM_SIGN_UP = 'CONFIRM_SIGN_UP'
export const CONFIRM_SIGN_IN = 'CONFIRM_SIGN_IN'

const RegistrationModal = React.lazy(() =>
  import('../Common/RegistrationModal'),
)

const StyledAuthLayoutModern = Styled.div`
  margin: 50px auto;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top:233px;
  }

  .landing-image {
    min-height: 500px;
    background: url(landing-page.jpeg) no-repeat;
    background-size: cover;
    text-align: center;
    flex-wrap: nowrap;
  }

  .sign-in-block {
    background-color: rgba(48,114,179,0.7);
    border-left: solid 1px white;
    color: ${({ theme }) => theme.colors.white};
  }

  .blue-block {
    margin-top: 60px;

  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 16px 0;
    margin-top: 40px;
    padding: 8px 20px 0;
  }

  .wrapper + .wrapper {
    margin-top: 8px;
  }

  .chunk-loading{
    background:#ffff;
    border-radius:20px;
    margin-bottom:40px;
  }
  
  @media (max-width: ${({ theme }) => theme.breakPoints.xSmall}) {
    .chunk-loading {
      width:100%;
      
    }
  }

  @media (width: 430px) and (height: 932px) {
    .wrapper {
      margin-top: 245px;
    }
  }

  @media (min-width: 834px) and (max-width: 1280px) {
    .wrapper {
      margin-top: 220px;
    }
  }

  @media (min-width: 1281px) and (max-width: 1599px) {
    .container {
      flex-direction: row-reverse;
    }

    .wrapper {
      position: relative;
      margin: 184px auto 0px;
    }
 }

  @media (min-width: 1600px) {
    .container {
      flex-direction: row-reverse;
    }

    .wrapper {
      position: relative;
      margin: 440px auto 0px
    }
  }

  @media (width: 1440px) and (height: 478px) {
    .wrapper {
      margin-top: 250px;
    }
  }
`

const AuthLayout = ({
  children,
  setAuthState,
  setAuthData,
  setUserInfo,
  setIsAuthenticated,
  authData,
  activeTab,
  authState,
}) => {
  const [modalShow, setModalShow] = useState(false)
// Only declare navigate once in the component body
const { logout: auth0Logout } = useAuth0()
  const context = useApiContext()
  const { pathname } = useLocation()
  // Define activeFormTab to fix ReferenceError
  const activeFormTab = SIGN_IN;
  const isSignupVerificationPage =
    activeFormTab && activeTab === CONFIRM_SIGN_UP

  const {
    // error: borrowerError,
    loading: loanLoading,
    data: loanData,
  } = context.loan
  const { data, loading } = useLoggedInUser()

  const handleLogout = useCallback(() => {
 localStorage.removeItem(GET_LOAN_KEY)
  localStorage.removeItem(GET_TRANSACTIONS_KEY)
  localStorage.removeItem(GET_PAPERLESS_KEY)
  localStorage.removeItem('ajs_user_traits')

  localStorage.removeItem('redirectAllowed') // Clear redirectAllowed flag
  localStorage.removeItem('mfaJustEnrolled') // Clear first enrolment
  localStorage.removeItem('paperlessOptOut') // Clear first verification
  auth0Logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  })
}, [auth0Logout])

  useIdleLogout(handleLogout)
const navigate = useNavigate();
useEffect(() => {
  // If user is logged in and hits root, send them to My Loan
  if (data && (pathname === '/' || pathname === '/finish-your-account')) {
    navigate('/my-loan', { replace: true });
  }
}, [data, pathname, navigate]);

  const [borrower] = loanData
    ? extractBorrowerAndCoborrowers(
        loanData,
        data?.['custom:person_id'],
      )
    : [null]

  return (
    <StyledAuthLayoutModern>
      {/* TODO remove we need to uncomment these banners */}
      {/* <BannerAuth0 /> */}
      {/* <BannerAuth0August /> */}
      <BannerMFAPreLoginFiveThousand />
      <BannerAnnouncing />
      <ScrollToTop />
      <Suspense fallback={null}>
        {activeFormTab === CREATE_ACCOUNT && (
          <RegistrationModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            page="sign in"
          />
        )}
      </Suspense>
      {data ? (
        <Container>
          <Row className="landing-image">
            <Col className="sign-in-block">
              <div className="blue-block"></div>
              <h1 className="welcome-title">
                Welcome <br />{' '}
                {loanData &&
                  borrower &&
                  `${borrower.firstName} ${borrower.lastName}`}
              </h1>
            </Col>
            <Col sm="7">
              <div className="main-content">{children}</div>
            </Col>
          </Row>
        </Container>
      ) : (
        <>
          <Container>
            <div>
              <Suspense
                fallback={
                  <div className="chunk-loading">
                    {' '}
                    <LoadingPage />{' '}
                  </div>
                }
              ></Suspense>
            </div>
            {/* {!isSignupVerificationPage && <LandingPageBannerModern />} */}
          </Container>

          {!isSignupVerificationPage && (
            <div className="wrapper">
              <InsuranceClaimBanner />
            </div>
          )}
          {!isSignupVerificationPage && (
            <div className="wrapper">
              <PrepaymentBanner />
            </div>
          )}

          {!isSignupVerificationPage && <CommonQuestionsModern />}
          {!isSignupVerificationPage && <CommonFormsModern />}
        </>
      )}
    </StyledAuthLayoutModern>
  )
}

export default AuthLayout
